export const TokenDisable = 'x-disable-token';
